<template>
<div id="news-list">
  <mainHeader  class="mainHeader" v-if="isHeader"></mainHeader>
  <div class="wrapper">
    <div class="section section1" :style="isHeader?'top:55px':'top:0px'">
      <div class="header">
        <div class="content" id="header">
          <div class="swiper-pagination-newslist" slot="pagination"></div>
        </div>
      </div>
    </div>
    <div class="section section2" ref="section2"  :style="isHeader?'top:110px':'top:55px'">
      <div class="content">
        <!-- 顶部提示信息 -->
        <div class="top-tip">
          <span class="refresh-hook">{{topTip}}</span>
        </div>
        <swiper class="swiperNewsList" :options="swiperOptionNewsList" ref="swiperNewsList">
          <swiper-slide class="slideList slideList1" v-for="(value,index) in categoryData"  :key="index">
            <div class="empty-box" v-show="value.list.length <= 0">
              <div class="tip">暂无文章</div>
            </div>
            <div class="slide slide1" v-for="(val,ind) in value.list" :key="ind" :style="{height:(val.thumbnail == null || val.thumbnail.length <= 0) ? '60px':'110px' }" @click="gotoNewsinfo(val.id)">
              <div class="box box1" v-show="(val.thumbnail == null || val.thumbnail.length <= 0)">
                <div class="title">{{val.title}}</div>
                <div class="time">{{val.created}}</div>
              </div>
              <div class="box box2" v-show="(val.thumbnail != null && val.thumbnail.length > 0)">
                <div class="image" :style="{backgroundImage:'url('+imageUrl+val.thumbnail+')'}"></div>
                <div class="title">{{val.title}}</div>
                <div class="time">{{val.created}}</div>
              </div>
            </div>
          </swiper-slide>
          </swiper>
        <!--   底部   -->
        <div class="bottom-tip">
          <span class="loading-hook">{{bottomTip}}</span>
        </div>
      </div>

    </div>

  </div>

<!--  <mainFooter class="mainFooter"></mainFooter>-->
</div>
</template>

<script>
import mainHeader from '../view/header'
import mainFooter from '../view/footer'
// import {Toast} from 'mint-ui'
import BScroll from 'better-scroll'

export default{
  data () {
    const _this = this
    return {
      imageUrl: this.utils.ResourceUrl,
      newsData: [],
      pages: [],
      scroll: '',
      topTip: '下拉刷新',
      bottomTip: '查看更多',
      alertTip: '刷新成功',
      // page: 1, // 页码
      activeIndex: 0, // swipper 当前下标
      categoryData: [
        {'id': '0', 'vid': '5,44,45,47,63,70', 'title': '全部', list: []},
        {'id': '1', 'vid': '5', 'title': '热点新闻', list: []},
        {'id': '2', 'vid': '44', 'title': '专家解读', list: []},
        {'id': '3', 'vid': '45', 'title': '展会资讯', list: []},
        {'id': '4', 'vid': '47', 'title': '消防科技', list: []},
        {'id': '5', 'vid': '63', 'title': '办事指南', list: []},
        {'id': '6', 'vid': '70', 'title': '地方规范', list: []}
      ],
      swiperOptionNewsList: {
        autoHeight: true,
        direction: 'horizontal',
        observer: true,
        observeParents: true,
        initialSlide: 0,
        pagination: {// 分页器
          el: '.swiper-pagination-newslist',
          clickable: true,
          renderBullet: function (index, className) {
            var categorys = [
              {'id': '0', 'vid': '5,44,45,47,63,70', 'title': '全部'},
              {'id': '1', 'vid': '5', 'title': '热点新闻'},
              {'id': '2', 'vid': '44', 'title': '专家解读'},
              {'id': '3', 'vid': '45', 'title': '展会资讯'},
              {'id': '4', 'vid': '47', 'title': '消防科技'},
              {'id': '5', 'vid': '63', 'title': '办事指南'},
              {'id': '6', 'vid': '70', 'title': '地方规范'}]
            var value = categorys[index]
            return '<span class="' + className + '">' + value.title + '<span></span></span>'
          }
        },
        fadeeffect: true,
        on: {
          slideChangeTransitionStart: function () {
            console.log('swiper-----------' + this.activeIndex)
            _this.activeIndex = this.activeIndex
            // console.log(_this.bottomTip)
            _this.loadData(_this.activeIndex)
            // document.getElementById('header').scrollLeft = '50%'
            // console.log(document.getElementById('header'))
          }
        }
      },
       isHeader: true,
    }
  },
  watch: {
    $router () {
    }
  },
  methods: {
    gotoNewsinfo: function (id) {
      console.log('========')

      this.$router.push({path: 'news-info', query: {newsID: id}})
    },
    initScroll () {
      var _this = this
      this.scroll = new BScroll(this.$refs.section2, {
        // probeType: 2,
        // bounceTime:700,      //回弹时间
        // pullUpLoad: {
        //   threshold: 10    //当上拉距离超过盒子高度的10px的时候,就派发一个上拉加载的事件
        // },
        // pullDownRefresh: {
        //   threshold: 10   // 当下拉长度距离盒子顶部的高度超过10px的时候,就派发一个下拉刷新的事件
        // },
        // useTransition:false,  // 防止iphone微信滑动卡顿
        // freeScroll: true,
        probeType: 1,
        // scrollY: true,
        // hasVerticalScroll: true,
        click: true,
        bounce: {
          top: true,
          bottom: true,
          left: true,
          right: true
        }, // 回弹 动画
        bounceTime: 800 // 回弹时间
      })
      // 滑动中
      this.scroll.on('scroll', function (position) {
        console.log(position)
        if (position.y > 30) {
          _this.topTip = '释放立即刷新'
        }
      })
      // 滑动结束
      this.scroll.on('touchEnd', function (position) {
        // console.log('===========' + position.y)
        // console.log('----------==' + _this.scroll.maxScrollY)
        // 刷新
        if (position.y > 30) { // 下拉刷新
          /*
           * 这里发送ajax刷新数据
           * 刷新后,后台只返回第1页的数据,无论用户是否已经上拉加载了更多
          */
          _this.pages[_this.activeIndex] = 1
          _this.loadData(_this.activeIndex)
        }
        // else
        if (position.y < _this.scroll.maxScrollY - 30) { // 上拉加载更多
          _this.bottomTip = '加载中...'
          _this.pages[_this.activeIndex] += 1
          _this.loadData(_this.activeIndex)
        }
      })
    },
    alertRefresh: function (info) {
      this.alertTip = this.alertTip || info
      document.getElementById('alert').style.display = 'block'
      setTimeout(function () {
        document.getElementById('alert').style.display = 'none'
      }, 1000)
    },
    reloadScroll: function (type) {
      // 0 下拉 1 上拉
      if (type === 0) {
      // 恢复文本值
        this.topTip = '下拉刷新'
        // 刷新成功后的提示
        this.alertRefresh('刷新成功')
        // 刷新列表后,重新计算滚动区域高度
        this.scroll.refresh()
      }
      if (type === 1) {
      // 恢复文本值
        this.bottomTip = '查看更多'
        // 加载更多后,重新计算滚动区域高度
        this.scroll.refresh()
      }
    },
    loadData: function (index) {
      var _this = this
      let category = this.categoryData[index]

      this.utils.GET(this.accountUrl + '/jpressContent/list?pageSize=10&pageNo=' + this.pages[index] + '&taxonomyIds=' + category.vid,
        function (result) {
          // 第一页
          if (_this.pages[index] === 1) {
            _this.categoryData[index].list = result.data.rows
            console.log(_this.categoryData)
            _this.reloadScroll(0)
          } else {
            _this.categoryData[index].list = _this.categoryData[index].list.concat(result.data.rows)
            console.log(_this.categoryData)
            _this.reloadScroll(1)
          }
        })
    }
  },
  components: { // 注册组件
    mainHeader,
    mainFooter
  },
  mounted () {
    for (var i = 0; i < this.categoryData.length; i++) {
      this.pages[i] = 1
    }
    console.log(this.pages)
    this.loadData(0)
    this.initScroll();
    this.isHeader = this.$route.query.isHeader && this.$route.query.isHeader==0 ? false : true
  }
}

</script>

<style scoped="scoped">
.mainHeader{
  position: fixed;
  top: 0px;
  height: 55px;
  width: 100%;
  z-index: 500;
}
.wrapper{
  background-color: #F6F6F6;
  width: 100%;
  height: 100%;
  /*margin-top: 55px;*/
}
.section1{
  position: absolute;
  top: 55px;
  height: 55px;
  width: 100%;
  overflow-x: scroll;
  border-bottom: #EEEEEE solid 1px;
  box-sizing: border-box;
  z-index: 200;

}
.section1 .header{
  position: relative;
  left: 0px;
  width: 640px;
  height: 55px;
  background-color: #FFFFFF;
  /*background-color: yellow;*/
}
.section1 .header .content{
  position: absolute;
  height: 55px;
  /*background-color: deepskyblue;*/
}
.section2{
  position: absolute;
  top: 110px;
  width: 100%;
  bottom: 0px;
  background-color: #f4f4f4;
  /*background-color: pink;*/
}
.section2 .content{
  min-height: 101%;
  /*background-color: yellowgreen;*/
}
.section2 .content .slideList{
  width: 100%;
  /*height: 100%;*/
  height: auto;
  /*min-height: 100%;*/
  /*background-color: yellow;*/
}
.section2 .content .slideList .empty-box {
  position: relative;
  width: 100%;
  height: 500px;
  /*background-color: #C41335;*/
  text-align: center;
  padding-top: 130px;

  font-size: 15px;
  color: #BEBEBE;
}
.slideList .slide{
  position: relative;
  width: 100%;
  height: 110px;
  background-color: #FFFFFF;
  margin-bottom: 5px;

}
.slideList .slide .box{
  /*position: absolute;*/
  /*height: 60px;
  width: 100%;*/
}
.slideList .slide .box1{
  position: absolute;
  height: 60px;
  width: 100%;
  /*border: solid 1px yellowgreen;*/
}
.slideList .slide .box2{
  position: absolute;
  height: 110px;
  width: 100%;
  /*border: solid 1px yellowgreen;*/

}
.slideList .slide .box1 .title{
  position: absolute;
  top: 10px;
  left: 15px;
  right: 15px;
  height: 20px;
  line-height: 20px;
  color: #000000;
  font-size: 15px;
  word-wrap:break-word;
  overflow: hidden;
  text-overflow: ellipsis;
}
.slideList .slide .box1 .time{
  position: absolute;
  top: 35px;
  left: 15px;
  right: 15px;
  height: 15px;
  line-height: 15px;
  color: #bebebe;
  font-size: 13px;
  word-wrap:break-word;
  overflow: hidden;
  text-overflow: ellipsis;
}
.slideList .slide .box2 .image{
  position: absolute;
  top: 19px;
  left: 15px;
  width: 115px;
  height: 72px;
  background-size: cover;
  background-position: center center;
}
.dimage{
  background-image: url(../assets/icon_new_default.png);
}
.slideList .slide .box2 .title{
  position: absolute;
  top: 20px;
  left: 140px;
  right: 15px;
  height: 40px;
  line-height: 20px;
  color: #000000;
  font-size: 15px;
  word-wrap:break-word;
  overflow: hidden;
  text-overflow: ellipsis;
}
.slideList .slide .box2 .time{
  position: absolute;
  top: 72px;
  left: 140px;
  right: 15px;
  height: 20px;
  line-height: 20px;
  color: #bebebe;
  font-size: 13px;
  word-wrap:break-word;
  overflow: hidden;
  text-overflow: ellipsis;
}

</style>



// WEBPACK FOOTER //
// src/view/news-list.vue